import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './NSSPage.scss';
import NSSLOGO from '../../assets/images/nss logo.png';
import Header from '../../components/ActivePath/Header';
import I2 from '../../assets/images/nss/image1.jpeg';
import I3 from '../../assets/images/nss/image2.jpeg';
import I4 from '../../assets/images/nss/image3.jpeg';
import I5 from '../../assets/images/nss/image4.jpeg';
import I6 from '../../assets/images/nss/image5.jpeg';
import I7 from '../../assets/images/nss/image6.jpeg';
import I8 from '../../assets/images/nss/image13.jpeg';
import I9 from '../../assets/images/nss/image8.jpeg';
import I10 from '../../assets/images/nss/image9.jpeg';
import I1 from '../../assets/images/nss/image10.jpeg';
import I11 from '../../assets/images/nss/image11.jpeg';
import I12 from '../../assets/images/nss/image12.jpeg';
import I13 from '../../assets/images/nss/image14.jpeg';
import I14 from '../../assets/images/nss/image15.jpeg';
import I15 from '../../assets/images/nss/image16.jpeg';
import I16 from '../../assets/images/nss/image17.jpeg';
import I17 from '../../assets/images/nss/image18.jpeg';
import I18 from '../../assets/images/nss/image19.jpeg';
import CoordinatorImg from '../../assets/images/profile/KUBERACHARI.jpg';

const NSSPage: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
      I1,
      I2,
      I3,
      I4,
      I5,
      I6,
      I7,
      I9,
      I10,
      I11,
      I8,
      I12,
      I13,
      I14,
      // I15,
      I16,
      I17,
      I18
    ];

  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="nss-page">
        <Header pageTitle="" breadcrumb="NSS" />
      {/* Header Section */}
      <div className="header" data-aos="fade-up">
        <h1>National Service Scheme (NSS)</h1>
        <p>The SJM Polytechnic NSS Unit</p>
        <img src={NSSLOGO} alt='NSS logo'></img>
      </div>
         {/* NSS Information Section */}
      <div className="nss-info" data-aos="fade-up">
        <p>
          The National Service Scheme (NSS) is an Indian government-sponsored public service program conducted by the Department of Youth Affairs and Sports of the Government of India, which was begun in 1969.
        </p>
        <p>
          Its primary aim is personality development through social (or community) service. The NSS motto is “Not me, not you, but we”. It expresses the essence of democratic living and upholds the need for service, an appreciation of another person’s point of view, and consideration for fellow human beings.
        </p>
        <p>
          The SJM Polytechnic also has an active NSS unit, with Sri Kuberachari, Lecturer in the Department of Electronics & Communication, SJMP Birur, serving as the NSS coordinator.
        </p>
        {/* NSS Coordinator Section */}
<div className="nss-coordinator" data-aos="fade-up">
  <h2>Meet Our NSS Coordinator</h2>
  <div className="coordinator-card">
    <img src={CoordinatorImg} alt="Kuberachari S H" />
    <div className="coordinator-info">
      <h3>Mr. Kuberachari S H</h3>
      <p><strong>Designation:</strong> Lecturer, Electronics & Communication Department</p>
      <p><strong>Qualification:</strong> B.E., M.Tech (E&C)</p>
      <p><strong>Experience:</strong> 15 Years</p>
      <p>
        Mr. Kuberachari is a passionate educator and dedicated NSS Coordinator at SJM Polytechnic, Birur.
        With 15 years of teaching experience, he actively inspires students to participate in social service and personal development through NSS initiatives.
      </p>
    </div>
  </div>
</div>

      </div>
{/* Gallery Section */}
<section className="gallery">
      <h2>NSS Gallery</h2>
      <div className="gallery-grid">
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Lab ${index + 1}`}
            className="gallery-img"
            onClick={() => setSelectedImage(src)}
          />
        ))}
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Enlarged View" className="lightbox-img" />
        </div>
      )}
    </section>
    </div>
  );
};

export default NSSPage;
